module.exports = __webpack_public_path__ + "img/UI_common_framelabelBX_01_5f2829395.png";